export default {
  ZH_CN: {
    today_work: "今日作业",
    history_work: "历史作业",
    work_name: "作业名称",
    publish_time: "发布时间",
    finish_time: "完成时间",
    type: "类型",
    placeholder_work_name: "请输入作业名称",
    number_of_questions: "回答题目数",
    accuracy: "正确率",
    publish_homework: "发布作业",
    select_class: "选择班级",
    please_select_class: "请选择班级",
    completed: "已完成",
    time: "次",
    question: "题",
    homework: "作业",
    person: "人",
    overview: "总览",
    ai_discussion: "AI对话讨论次数详细",
    reading_comprehension: "阅读理解正确率详细",
    quiz_questions: "问答题正确率详细",
    finished_rate: "完成率",
    finished_students: "已完成",
    unfinished_students: "未完成",
    please_select_courseware: "请选择课件",
    correct_answer: "正确答案"
  },
  EN: {
    today_work: "Today's Homework",
    history_work: "Past Homework",
    work_name: "Homework Name",
    publish_time: "Published At",
    finish_time: "Completed At",
    type: "Type",
    placeholder_work_name: "Enter homework name",
    number_of_questions: "Questions Answered",
    accuracy: "Accuracy",
    publish_homework: "Assign Homework",
    select_class: "Select Class",
    please_select_class: "Please select a class",
    completed: "Completed",
    time: "time(s)",
    question: "questions",
    homework: "Homework",
    person: "person(s)",
    overview: "Overview",
    ai_discussion: "AI Discussion Count Details",
    reading_comprehension: "Reading Comprehension Accuracy Details",
    quiz_questions: "Quiz Question Accuracy Details",
    finished_rate: "Completion Rate",
    finished_students: "Completed",
    unfinished_students: "Not Completed",
    please_select_courseware: "Please select courseware",
    correct_answer: "Correct Answer"
  },
  ZH_HK: {
    today_work: "今日作業",
    history_work: "歷史作業",
    work_name: "作業名稱",
    publish_time: "發佈時間",
    finish_time: "完成時間",
    type: "類型",
    placeholder_work_name: "請輸入作業名稱",
    number_of_questions: "回答題目數",
    accuracy: "正確率",
    publish_homework: "發佈作業",
    select_class: "選擇班級",
    please_select_class: "請選擇班級",
    completed: "已完成",
    time: "次",
    question: "題",
    homework: "作業",
    person: "人",
    overview: "總覽",
    ai_discussion: "AI對話討論次數詳細",
    reading_comprehension: "閱讀理解正確率詳細",
    quiz_questions: "問答題正確率詳細",
    finished_rate: "完成率",
    finished_students: "已完成人數",
    unfinished_students: "未完成人數",
    please_select_courseware: "請選擇課件",
    correct_answer: "正確答案"
  },
  es: {
    today_work: "Tarea de hoy",
    history_work: "Tareas anteriores",
    work_name: "Nombre de la tarea",
    publish_time: "Fecha de publicación",
    finish_time: "Fecha de finalización",
    type: "Tipo",
    placeholder_work_name: "Ingrese el nombre de la tarea",
    number_of_questions: "Preguntas respondidas",
    accuracy: "Precisión",
    publish_homework: "Asignar tarea",
    select_class: "Seleccionar grupo",
    please_select_class: "Seleccione un grupo",
    completed: "Completado",
    time: "veces",
    question: "preguntas",
    homework: "Tarea",
    person: "persona(s)",
    overview: "Resumen",
    ai_discussion: "Detalles del número de discusiones con IA",
    reading_comprehension: "Detalles de precisión en comprensión lectora",
    quiz_questions: "Detalles de precisión en preguntas de respuesta abierta",
    finished_rate: "Tasa de finalización",
    finished_students: "Completado",
    unfinished_students: "No completado",
    please_select_courseware: "Por favor seleccione material educativo",
    correct_answer: "Respuesta correcta"
  }
};
